function _defineProperty(obj, key, value) { if (key in obj) { Object.defineProperty(obj, key, { value: value, enumerable: true, configurable: true, writable: true }); } else { obj[key] = value; } return obj; }

import { Controller } from 'stimulus';
export default class _class extends Controller {
  toggle(e) {
    e.preventDefault();
    this.checkboxTargets.forEach(checkbox => {
      checkbox.checked = e.target.checked;
    });
  }

}

_defineProperty(_class, "targets", ['checkbox']);